import { Component,  Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FilterAction } from '@shared-features/models/filter-action.model';
import { FilterService } from '../../services/filter.service';
import { DateRangeType, FormAction } from '@shared-features/enums/shared-enums.enum';
import { TabGroup } from '@shared-features/enums/tab.enum';
import { TruckOwnershipType } from '@shared-features/enums/fleets.enum';
import { BaseComponent } from '@shared-features/components/base-component/base.component';
import { FunctionUtil } from '@shared/utils';
import { ConfigConstant } from '@shared/constants';
import { Lookup } from '@shared-features/models/Lookup.model';
@Component({
  selector: 'app-trucks-report-filter',
  templateUrl: './trucks-report-filter.component.html',
  styleUrls: ['./trucks-report-filter.component.scss'],
})

export class TrucksReportFilterComponent extends BaseComponent implements OnInit {
  @Input() action: Observable<FilterAction>;
  @Input() tabGroup: TabGroup;
  filterActionSubscription: Subscription;
  form: FormGroup;
  params: any = null;
  sharedConstants = ConfigConstant;
  dateRangeType = DateRangeType;
  ownershipType: TruckOwnershipType;
  TruckOwnershipType = TruckOwnershipType;

  OwnershipTypeOptions = Object.keys(TruckOwnershipType).map((key) =>
  Object.assign(new Lookup(), {
    id: TruckOwnershipType[key] ,
    value:  this.translate('Enum.Ownership.' + key),
  })
);

  constructor(private filterService: FilterService,  private activatedRoute: ActivatedRoute) {
    super();
  }

  ngOnInit(): void {
    this.subscribeToQueryParams();
    this.subscribeToFilterAction();
    this.initForm();
  }

  subscribeToQueryParams(): void {
    this.activatedRoute.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      if (params && Object.keys(params).length !== 0) {
        this.params = params;
      }
    });
  }

  getFilterValuesBasedOnURLParams() {
    return {
      dateRange: this.params.dateRange === DateRangeType.ALL_TIME ? DateRangeType.ALL_TIME : String(this.params.dateRange),
      startFrom: this.params.startFrom ? String(this.params.startFrom) : null,
      endAt: this.params.endAt ? String(this.params.endAt) : null,
      ownershipType: this.params.ownershipType === TruckOwnershipType.Owned ? TruckOwnershipType.Rented : String(this.params.ownershipType),
    };
  }

  initForm() {
    if (this.params && Object.keys(this.params).length !== 0) {
      const filterValues = this.getFilterValuesBasedOnURLParams();
      this.form = new FormGroup({
        dateRange: new FormControl({ range: filterValues.dateRange || DateRangeType.TODAY, startFrom:filterValues.startFrom ||  '', endAt: filterValues.endAt ||  '' }),
        ownershipType: new FormControl(this.params.ownershipType ? this.OwnershipTypeOptions.filter(item => item.value == this.params.ownershipType ) : ConfigConstant.ALL),
      });
    } else {
      this.form = new FormGroup({
        dateRange: new FormControl({ range: DateRangeType.TODAY, startFrom: '', endAt: '' }),
        ownershipType: new FormControl(ConfigConstant.ALL),
      });
    }

  }

  subscribeToFilterAction() {
    this.action.pipe(takeUntil(this.destroy$)).subscribe((action: any) => {
      switch (action) {
        case FormAction.Reset:
          this.resetForm();
          break;

        case FormAction.Cancel:
          this.cancelChanges();
          break;

        case FormAction.Submit:
          this.submitForm();
          break;
      }
    });
  }

  resetForm() {
    this.form.controls['dateRange'].setValue(DateRangeType.ALL_TIME);
    this.form.controls['ownershipType'].setValue(ConfigConstant.ALL);
    this.submitForm();
  }

  cancelChanges() {
    if (this.params && Object.keys(this.params).length !== 0) {
      const filterValues = this.getFilterValuesBasedOnURLParams();
      this.form.setValue({
        dateRange: { range: filterValues.dateRange, startFrom: filterValues.ownershipType, endAt: filterValues.endAt },
        ownershipType: filterValues.ownershipType,
      });
    } else {
      this.resetForm();
    }
  }

  submitForm() {
    const submittedFilterValues = this.form.value;

    if (
      this.form.controls.dateRange.value.startFrom &&
      this.form.controls.dateRange.value.endAt &&
      this.form.controls.dateRange.value.range === DateRangeType.CUSTOM
    ) {
      submittedFilterValues['dateRange'].startFrom = FunctionUtil.convertDate(this.form.controls.dateRange.value.startFrom);
      submittedFilterValues['dateRange'].endAt = FunctionUtil.convertDate(this.form.controls.dateRange.value.endAt);
    } else {
      submittedFilterValues['dateRange'].startFrom = null;
      submittedFilterValues['dateRange'].endAt = null;
    }
    submittedFilterValues['ownershipType'] = this.form.controls.ownershipType.value.id;
    submittedFilterValues.tabGroup = this.tabGroup;
    submittedFilterValues.startFrom = submittedFilterValues.dateRange?.startFrom;
    submittedFilterValues.endAt = submittedFilterValues.dateRange?.endAt;
    submittedFilterValues.dateRange = submittedFilterValues.dateRange?.range;
    this.filterService.navigateToTargetPageWithFilter(submittedFilterValues);
  }
}
